module.exports = __webpack_public_path__ + "media/src/images/no_image-c748383de0278fc4f03cd60591747161.png";